<div style="background: url('assets/img/regbackground.jpg');background-size: cover;height: 100%;position: absolute;width: 100%;">
  <!--loader-->
  <div *ngIf="regLoader" style="background: rgba(255, 255, 255, 0.69);width: 100%;text-align: center;height: 100%;position: fixed;padding-top: 35vh;z-index: 9;">
    <img class="animated infinite pulse" src="images_ext/logo1.png" style="width: 125px;">
  </div>

  <div class="container registration">

    <div class="row">
      <div class="col-md-12 text-center" style="margin-top: 5vh;">
        <h3 *ngIf="!signinemail" style="font-weight: 100;color: #828282;margin-bottom: 0;">Register with {{ brand.name }}</h3>
        <h3 *ngIf="signinemail" style="font-weight: 100;color: #828282;margin-bottom: 0;">Find your school personal login</h3>
        <p style="color: #b5b5b5;;">Platform for Educational Institutions</p>
      </div>
    </div>


    <div *ngIf="regform" class="row reg-form">
      <div class="col-md-12" style="margin: 3em 0em;margin-bottom: 0;">
        <div class="col-md-3 col-sm-6 text-center">
          <img src="images_ext/logo1.png" style="width: 175px;">
          <h4 class="text-lg text-bold text-primary" style="font-size: 1.5em;">{{ brand.name | uppercase }}</h4>
        </div>
        <div class="col-md-9 col-sm-6">
          <form class="form">
            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control"  [class.invalid] = "invalidregisterName" [(ngModel)]= "registerName" [ngModelOptions]="{standalone: true}">
                <label for="regular1">Your Name<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterName">Invalid Name</span>
              </div>
            </div>

            <div class="col-sm-8">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [class.invalid] = "invalidregisterSchoolName" [(ngModel)]= "registerSchoolName" [ngModelOptions]="{standalone: true}">
                <label for="regular1">School Name<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolName">Invalid School Name</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [class.invalid] = "invalidregisterSchooolEmail" [(ngModel)]= "registerSchooolEmail" [ngModelOptions]="{standalone: true}">
                <label for="regular1">Email Address<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchooolEmail">Invalid Email</span>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchooolEmail2">Email already exist</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [class.invalid] = "invalidregisterSchoolContact" [(ngModel)]= "registerSchoolContact" [ngModelOptions]="{standalone: true}" maxlength="10">
                <label for="regular1">Contact Number<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolContact">Invalid Contact Number</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <select name="select1" class="form-control" [(ngModel)]= "registerSchoolCountry" [ngModelOptions]="{standalone: true}">
                  <option value="">Select Country</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Åland Islands">Åland Islands</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="American">American Samoa</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antarctica">Antarctica</option>
                  <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermuda">Bermuda</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia, Plurinational State of">Bolivia, Plurinational State of</option>
                  <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba</option>
                  <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Bouvet Island">Bouvet Island</option>
                  <option value="Brazil">Brazil</option>
                  <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                  <option value="Brunei Darussalam">Brunei Darussalam</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Cayman Islands">Cayman Islands</option>
                  <option value="Central African Republic">Central African Republic</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Christmas Island">Christmas Island</option>
                  <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo">Congo</option>
                  <option value="Congo, the Democratic Republic of the">Congo, the Democratic Republic of the</option>
                  <option value="Cook Islands">Cook Islands</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Curaçao">Curaçao</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="ET">Ethiopia</option>
                  <option value="Ethiopia">Falkland Islands (Malvinas)</option>
                  <option value="Faroe Islands">Faroe Islands</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="French Guiana">French Guiana</option>
                  <option value="French Polynesia">French Polynesia</option>
                  <option value="French Southern Territories">French Southern Territories</option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Greece">Greece</option>
                  <option value="Greenland">Greenland</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guadeloupe">Guadeloupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guernsey">Guernsey</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Heard Island and McDonald Islands">Heard Island and McDonald Islands</option>
                  <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Isle of Man">Isle of Man</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jersey">Jersey</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                  <option value="Korea, Republic of">Korea, Republic of</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Macao">Macao</option>
                  <option value="Macedonia, the former Yugoslav Republic of">Macedonia, the former Yugoslav Republic of</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Martinique">Martinique</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                  <option value="Moldova, Republic of">Moldova, Republic of</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="New Caledonia">New Caledonia</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk Island">Norfolk Island</option>
                  <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Pitcairn">Pitcairn</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Réunion">Réunion</option>
                  <option value="Romania">Romania</option>
                  <option value="Russian Federation">Russian Federation</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Barthélemy">Saint Barthélemy</option>
                  <option value="Saint Helena, Ascension and Tristan da Cunha">Saint Helena, Ascension and Tristan da Cunha</option>
                  <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Martin (French part)">Saint Martin (French part)</option>
                  <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                  <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Sint Maarten (Dutch part)">Sint Maarten (Dutch part)</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                  <option value="Swaziland">Swaziland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                  <option value="Taiwan, Province of China">Taiwan, Province of China</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Timor-Leste">Timor-Leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="United Arab Emirates">United Kingdom</option>
                  <option value="United States">United States</option>
                  <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Venezuela, Bolivarian Republic of">Venezuela, Bolivarian Republic of</option>
                  <option value="Viet Nam<">Viet Nam</option>
                  <option value="Virgin Islands, British">Virgin Islands, British</option>
                  <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                  <option value="Wallis and Futuna">Wallis and Futuna</option>
                  <option value="Western Sahara">Western Sahara</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
                <label>Select Country<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolCountry">Invalid Country</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [(ngModel)]= "registerSchoolState" [ngModelOptions]="{standalone: true}">
                <label for="regular1">State<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolState">Provide state</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [(ngModel)]= "registerSchoolLocality" [ngModelOptions]="{standalone: true}">
                <label for="regular1">Locality<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolLocality">Provide locality</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [(ngModel)]= "registerSchoolAddress" [ngModelOptions]="{standalone: true}">
                <label for="regular1">Address<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolAddress">Provide address</span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [class.invalid] = "invalidregisterSchoolAreaPinCode" [(ngModel)]= "registerSchoolAreaPinCode" [ngModelOptions]="{standalone: true}">
                <label for="regular1">School Area Pincode<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolAreaPinCode">Invalid Pincode</span>
              </div>
            </div>


            <div class="col-sm-8">
              <div class="form-group col-md-12">
                <div class="input-group">
                  <div class="input-group-content">
                    <input type="text" class="form-control" [class.invalid] = "invalidregisterSchoolUrl" [(ngModel)]= "registerSchoolUrl" [ngModelOptions]="{standalone: true}">
                    <label>School URL &nbsp;(<b>schoolname</b>.{{ brand.domainSuffix }})<span style="color: red">*</span></label>
                    <span style="color: #F44336;font-size: 11px;" *ngIf="invalidregisterSchoolUrl">Invalid Url(should not contain any special characters & min length 3) Or It's an exciting one</span>
                  </div>
                  <div class="input-group-btn" style="padding-left: 0;">
                    <button class="btn btn-default" type="button" style="text-transform: lowercase;background: rgba(255, 255, 255, 0);color: #6f6f6f;border: none;font-weight: 700;padding-left: 5px;">.{{ brand.domainSuffix }}</button>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-sm-6">
              <div class="form-group col-md-12">
                <input type="text" class="form-control" [class.invalid] = "invalidregisterSchoolUsername" [(ngModel)]= "registerSchoolUsername" [ngModelOptions]="{standalone: true}">
                <label>User Name<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolUsername">Invalid Username(should not contain any special characters & min length 3)</span>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolUsername2">Username already exist</span>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group col-md-12">
                <input type="password" class="form-control" [class.invalid] = "invalidregisterSchoolPassword" [(ngModel)]= "registerSchoolPassword" [ngModelOptions]="{standalone: true}">
                <label>Password<span style="color: red">*</span></label>
                <span style="color: #F44336;font-size: 11px;position: absolute;" *ngIf="invalidregisterSchoolPassword">Invalid Password(min length 6)</span>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="col-md-12" style="padding: 10px 35px 35px 35px;text-align: center;font-size: 12px;">
        <div class="checkbox checkbox-styled hide" style="color:#929292;">
          <label>
            <!--<input type="checkbox" value="" id="termsOfServiceCheck">-->
            <span style="font-size: 12px;">By clicking on PROCEED you agree to {{ brand.name }}'s <a target="_blank" style="text-decoration: underline;color: var(--brand-primary-color);" [routerLink]="['/privacy']">Privacy Policy</a> and <a target="_blank" style="text-decoration: underline;color: var(--brand-primary-color);" [routerLink]="['/terms']">Terms of Use.</a></span>
          </label>
        </div>


        <button (click)="proceedRegister()" type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false" style="margin-left: 1em;padding: 5px 35px;">Proceed</button>

        <div class="col-md-12" style="margin-top: 20px;">
          <p style="color: #929292;font-size: 12px;">Already have an account with {{ brand.name | uppercase }}, Please SignIn <a (click)="signinWithEmail()" style="text-decoration: underline;color: var(--brand-primary-color); cursor: pointer">here</a></p>
        </div>
      </div>
    </div>

    <div *ngIf="emailconfirm" class="row email-confirm" style="height: 700px;">
      <div class="col-md-12" style="margin: 0;">
        <div class="col-md-6 col-sm-12 col-md-offset-3">

          <div class="col-sm-12 text-center">
            <img src="images_ext/logo1.png" style="width: 135px;">
            <h4 class="text-lg text-bold text-primary" style="font-size: 1.5em;">{{ brand.name | uppercase }}</h4>
          </div>
          <form class="form">
            <div class="col-sm-12">
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-content">
                    <input type="text" class="form-control" [(ngModel)]= "registerSchoolVerificationCodeGet" [ngModelOptions]="{standalone: true}">
                    <label >Enter the verification code send to your mobile number</label>
                    <span style="color: #F44336;font-size: 11px;" *ngIf="invalidVerificationCode">Invalid verification code</span>
                  </div>
                  <div class="input-group-btn">
                    <button (click)="registerSchool()" class="btn btn-default" type="button" style="background: var(--brand-primary-color);color: white;border: var(--brand-primary-color);">Register</button>
                  </div>
                </div>
              </div>
              <p *ngIf="resendOtpTrials < 3" style="color: #b5b5b5;padding-top: 10px;text-align: center;font-size: 12px;">Didn't get the verification code?  <a (click)="resendVerificationCode()"  style="text-decoration: underline;color: var(--brand-primary-color);cursor: pointer"> resend </a>&nbsp; (attempts remaining {{3 - resendOtpTrials}})</p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf="signinemail" class="row signin-email">
      <div class="col-md-12" style="margin: 0;">
        <div class="col-md-4 col-sm-12 col-md-offset-4" style="width: 40%;margin-left: 30%;">
          <div class="col-sm-12 text-center">
            <img src="images_ext/logo1.png" style="width: 135px;">
            <h4 class="text-lg text-bold text-primary" style="font-size: 1.5em;">{{ brand.name | uppercase }}</h4>
          </div>
          <form class="form">
            <div class="col-sm-12 text-center">
              <div class="form-group" style="">
                <input type="text" class="form-control text-center" [(ngModel)]= "signinWithEmailData" [ngModelOptions]="{standalone: true}">
                <label>Enter your registered Email Id</label>
                <span style="color: #F44336;font-size: 12px;position: absolute;left: 0;right: 0;" *ngIf="invalidSignUpEmail">Invalid email</span>
              </div>
              <button (click)="signInEmail()" type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false" style="margin-left: 1em;padding: 5px 35px;">SignIn</button>
            </div>
            <div class="col-md-12" style="margin-top: 20px;">
              <p style="color: #929292;font-size: 12px;">Don't have an account with {{ brand.name | uppercase }}, Please Register <a (click)="signinemail = false;emailconfirm = false;regform = true" style="text-decoration: underline;color: var(--brand-primary-color); cursor: pointer">here</a></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="container signin-section hide">
    <div class="row">
      <div class="col-md-12 text-center" style="margin-top: 5vh;">
        <h3 style="font-weight: 100;color: #828282;margin-bottom: 0;">Welcome to {{ brand.name | uppercase }}</h3>
        <p style="color: #b5b5b5;;">Platform for Educational Institutions</p>
      </div>
    </div>

    <div class="col-md-12" style="margin: 0;">
      <div class="col-md-4 col-sm-12 col-md-offset-4">
        <div class="col-sm-12 text-center">
          <img src="images_ext/logo1.png" style="width: 135px;">
          <h4 class="text-lg text-bold text-primary" style="font-size: 1.5em;">{{ brand.name | uppercase }}</h4>
        </div>
        <div class="col-md-12 text-center">
          <h4 style="margin: 0;margin-bottom: 20px;color: #828282;">Capricon International School</h4>
        </div>
        <form class="form">
          <div class="col-sm-12">
            <div class="form-group" style="">
              <input type="text" class="form-control">
              <label>Enter your User Name</label>
            </div>
            <div class="form-group" style="">
              <input type="text" class="form-control">
              <label>Enter Password</label>
            </div>
            <div class="col-md-12 text-center" style="padding: 0;">
              <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false" style="margin-left: 1em;padding: 5px 35px;margin: 0;">Login</button>
              <p style="color: #b5b5b5;/* float: right; */padding-top: 10px;">Forgot password? Click <a href="#" style="text-decoration: underline;color: var(--brand-primary-color);">here</a></p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>





  <!-- BEGIN JAVASCRIPT -->
  <script src="assets/js/libs/jquery/jquery-1.11.2.min.js"></script>
  <script src="assets/js/libs/jquery/jquery-migrate-1.2.1.min.js"></script>
  <script src="assets/js/libs/jquery-ui/jquery-ui.min.js"></script>
  <script src="assets/js/libs/bootstrap/bootstrap.min.js"></script>
  <script src="assets/js/libs/spin.js/spin.min.js"></script>
  <script src="assets/js/libs/autosize/jquery.autosize.min.js"></script>
  <script src="assets/js/libs/moment/moment.min.js"></script>
  <script src="assets/js/libs/flot/jquery.flot.min.js"></script>
  <script src="assets/js/libs/flot/jquery.flot.time.min.js"></script>
  <script src="assets/js/libs/flot/jquery.flot.resize.min.js"></script>
  <script src="assets/js/libs/DataTables/jquery.dataTables.min.js"></script>
  <script src="assets/js/libs/DataTables/extensions/ColVis/js/dataTables.colVis.min.js"></script>
  <script src="assets/js/libs/DataTables/extensions/TableTools/js/dataTables.tableTools.min.js"></script>
  <script src="assets/js/libs/nanoscroller/jquery.nanoscroller.min.js"></script>
  <script src="assets/js/core/source/App.js"></script>
  <script src="assets/js/core/source/AppNavigation.js"></script>
  <script src="assets/js/core/source/AppOffcanvas.js"></script>
  <script src="assets/js/core/source/AppCard.js"></script>
  <script src="assets/js/core/source/AppForm.js"></script>
  <script src="assets/js/core/source/AppNavSearch.js"></script>
  <script src="assets/js/core/source/AppVendor.js"></script>
  <script src="assets/js/core/demo/Demo.js"></script>
  <script src="assets/js/core/demo/DemoTableDynamic.js"></script>
  <script src="assets/js/core/demo/DemoUIMessages.js"></script>
</div>
